import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { MaintenanceSettings } from '@/models'
import { resetQueries } from '@/utils/api'

import { getMaintenanceSettingsQueryKey } from './get-maintenance-settings'

export const updateMaintenanceSettings = async (data: MaintenanceSettings): Promise<void> => {
  await authAPI.put('/v2/maintenance/settings', data)
}

export const useUpdateMaintenanceSettings = (buildingId: number) => {
  return useMutation({
    mutationFn: updateMaintenanceSettings,
    onSuccess: () => {
      resetQueries(getMaintenanceSettingsQueryKey({ buildingId }))
    },
  })
}
